import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import OperationalDashboardLayer from "../components/dashboards/OperationalDashboardLayer";

const OperationalDashboardPage = () => (
  <MasterLayout pageTitle="Operational Dashboard">
    <OperationalDashboardLayer />
  </MasterLayout>
);

export default OperationalDashboardPage;
